import React from 'react';

import { graphql, PageProps } from 'gatsby';

import { Language } from '@mewa/types';

import t from '../../libs/translate';
import { NavigationData } from '../components/header/types';
import { QuickNavigation } from '../components/quick-navigation/a-b-testing-variant';
import { trackAndNavigate } from '../components/quick-navigation/helper';
import { StrapiStageImage } from '../components/strapi/stage-image';
import { GlobalPageContext } from '../types';
import { StrapiResponsiveImageData } from './dynamic-content-page/content-components/image';

export const query = graphql`
  query (
    $marketRegex: String!
    $lang: String!
    $locale: String!
    $translationFilter: String!
  ) {
    ...NavigationFragment

    translations: allTranslation(
      filter: { locale: { regex: $translationFilter } }
    ) {
      nodes {
        page_does_not_exist_headline
        lang
      }
    }

    defaultTranslations: translation(locale: { eq: $locale }) {
      show_products
    }

    strapiHomepage(locale: { eq: $locale }) {
      Stage {
        image: Image {
          ...StrapiImageFragment
        }
      }
    }
  }
`;

type Props = NavigationData & {
  translations: {
    nodes: {
      page_does_not_exist_headline: string;
      lang: Language;
    }[];
  };
  defaultTranslations: {
    show_products: string;
  };
  strapiHomepage: {
    Stage: {
      image: StrapiResponsiveImageData;
    };
  };
};

type PageContext = GlobalPageContext & {
  translationFilter: string;
};

const IndexRoute = ({
  data: {
    navigationIndustries: { nodes: industries },
    navigationServiceSegments: { nodes: serviceSegments },
    navigationLinks,
    strapiHomepage,
    translations,
    defaultTranslations,
    headerAndFooterTranslations,
    searchPageTranslations,
  },
  pageContext,
}: PageProps<Props, PageContext>) => {
  return (
    <StrapiStageImage
      data={{
        headline: translations.nodes.map((langTranslations) =>
          t(langTranslations, 'page_does_not_exist_headline'),
        ),
        subline: '',
        image: strapiHomepage.Stage.image,
      }}
    >
      <QuickNavigation
        langPrefix={pageContext.langPrefix}
        industries={industries}
        serviceSegments={serviceSegments}
        translations={{
          quickNavHeadline: t(headerAndFooterTranslations, 'quicknav_headline'),
          quickNavAllIndustries: t(
            headerAndFooterTranslations,
            'quicknav_all_industries',
          ),
          quickNavAlProducts: t(
            headerAndFooterTranslations,
            'quicknav_all_products',
          ),
          quickNavIndustryPlaceholder: t(
            headerAndFooterTranslations,
            'quicknav_industry_placeholder',
          ),
          quickNavProductsPlaceholder: t(
            headerAndFooterTranslations,
            'quicknav_products_placeholder',
          ),
          search: t(searchPageTranslations, 'general_search'),
          showProducts: t(defaultTranslations, 'show_products'),
        }}
        productOverviewSlug={navigationLinks.navigation.productMenu.slug}
        nonClothingSlug={navigationLinks.navigation.nonClothing.slug}
        onSearch={(urlWithoutLangPrefix: string) => {
          trackAndNavigate(`${pageContext.langPrefix}/${urlWithoutLangPrefix}`);
        }}
        featureDev={pageContext.featureDev}
      />
    </StrapiStageImage>
  );
};

IndexRoute.noContactTeaser = true;

export default IndexRoute;
